import React from 'react';

const hotelTupleWrapper = (props) => <div {...props} className={`u-flex phone-f-column u-height200 u-phone-heightAuto u-flex u-backgroundColorWhite u-borderRadius4 u-boxShadowThin u-overflowHidden u-width100Percent mt-4 mb-4 ml-auto mr-auto`}>{props.children}</div>

export default hotelTupleWrapper;


// WEBPACK FOOTER //
// ./src/components/Hotel/HotelTuple/HotelTupleWrapper/HotelTupleWrapper.js